import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"
import Spinner from "@cirrus/legacy/app-components/spinner/spinner/index.jsx"
import classNames from "classnames"
import { ErrorResultMessage } from "@cirrus/legacy/app-components/entries/lib.js"
import PropTypes from "prop-types"
import React, { Component as C, Children } from "react"

import Html from "./html.jsx"
import RowHtml from "./rowHtml.jsx"
import styles from "./table-body.less"

class TableBody extends C {
  static displayName = "TableBody"

  static propTypes = {
    className: PropTypes.string,
    noRowsText: PropTypes.string,
    isDataLoading: PropTypes.bool,
    loaded: PropTypes.bool,
    pending: PropTypes.bool,
    error: PropTypes.any,
    dataSortableContainerId: PropTypes.string,
    id: PropTypes.string
  }

  static defaultProps = {
    doShowNoRowsText: true,
  }

  mapChildren(children) {
    return Children.map(children, (child, index) => {
      return React.cloneElement(child, {
        isLastRow:
          child.props.isLastRow || (!child.props.isNotLastRow && children.length - 1 === index),
      })
    })
  }

  getContent() {
    const {
      doShowNoRowsText,
      error,
      isDataLoading,
      isNoRowsTextReadable,
      loaded,
      noRowsText,
      onFetchDataRequest,
      pending,
    } = this.props

    if (error) {
      return (
        <RowHtml type={this.props.htmlType} className={styles.emptyRow}>
          <ErrorResultMessage
            className={styles.dataFetchingErrorMessage}
            action={onFetchDataRequest}
            pending={pending}
          />
        </RowHtml>
      )
    }

    if (isDataLoading || loaded === false) {
      return (
        <RowHtml type={this.props.htmlType} className={styles.emptyRow}>
          <div className={styles.spinnerContainer}>
            <Spinner />
          </div>
        </RowHtml>
      )
    }

    const { children } = this.props
    const childrenArray = Children.toArray(children)

    if (childrenArray && childrenArray.length) {
      return this.mapChildren(childrenArray)
    }

    return doShowNoRowsText ? (
      <RowHtml type={this.props.htmlType} className={styles.emptyRow}>
        <span
          className={classNames(styles.empty, {
            "readspeaker-readable-area": isNoRowsTextReadable,
          })}>
          {noRowsText ? noRowsText : appStorage.translationFunction("General:NoItems")}
        </span>
      </RowHtml>
    ) : null
  }

  render() {
    return (
      <Html
        type={this.props.htmlType}
        className={this.props.className}
        id={this.props.id}
        dataSortableContainerId={this.props.dataSortableContainerId}>
        {this.getContent()}
      </Html>
    )
  }
}

export default TableBody
